// extracted by mini-css-extract-plugin
export default {"container":"Earn_container__e4VHs","text":"Earn_text__mOVSc","image":"Earn_image__JMW2O"};